<advanced-filter (onSubmit)="applyFilter($event)" *ngIf="isCoLogin"></advanced-filter>
<app-spinner-overlay [showSpinner]="loading"></app-spinner-overlay>
<wl-card heading="Summary" subheading1="{{subheading1}}" subheading2="{{subheading2}}" *ngIf="showSummary">

  <wl-date-input (dateRangeSelected)="onDateRangeSelected($event)" *ngIf="!isCoLogin"></wl-date-input>

  <span *ngIf="showSelectedDate && !isCoLogin" class="datetext">&nbsp;&nbsp;{{selectedDate}}&nbsp;&nbsp;<img
      src="../../../assets/fontawesome-web/svgs/regular/rectangle-xmark.svg" class="h-15px"
      (click)="closeButtonClick()">
  </span>
  <span *ngIf="showSelectedDate && !isCoLogin" class="datetext">&nbsp;&nbsp;{{selectedDate}}&nbsp;&nbsp;<img
      src="../../../assets/fontawesome-web/svgs/regular/rectangle-xmark.svg" class="h-15px"
      (click)="closeButtonClick()">
  </span>
  <br>


  <!-- `table-scrollable` was a dead class - it is not defined in any stylesheet,
       so this table had no overflow handling at all and the long state labels
       ("w/w Total Applications Disbursed ( Accounts Opened)") widened the page
       on a phone. .table-responsive is the real class, on a wrapper. -->
  <div class="table-responsive">
  <table class="table table-hover">
    <thead>
      <tr>
        <th>Application State</th>
        <th class="center-aligned">No. of Accounts<br></th>
        <th class="center-aligned">Amount in Rupees</th><br>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Total Applications Received</td>
        <td class="vertical-align-unset text-center">{{allUsers.totalApplication?
          allUsers.totalApplication : 0}}</td>
        <td class="vertical-align-unset text-center"> - </td>
      </tr>

      <tr>
        <td>w/w Total Applications Sanctioned</td>
        <td class="vertical-align-unset text-center">{{allUsers.sanctionedCount?
          allUsers.sanctionedCount : '0'}}</td>
        <td class="vertical-align-unset text-center">{{allUsers.sanctionedAmount?
          allUsers.sanctionedAmount : '0'}}</td>
      </tr>
      <tr>
      <td>w/w Total Applications Disbursed ( Accounts Opened)</td>
      <td class="vertical-align-unset text-center">{{allUsers.disbursedCount?
        allUsers.disbursedCount : '0'}}</td>
      <td class="vertical-align-unset text-center">{{allUsers.disbursedAmount?
        allUsers.disbursedAmount : '0'}}</td>
      </tr>


      <tr>
        <td>Failure Applications</td>
        <td class="vertical-align-unset text-center">{{allUsers.failureCountAfterReference?
          allUsers.failureCountAfterReference : '0'}}</td>
        <td class="vertical-align-unset text-center"> - </td>
      </tr>
      <tr>
        <td>Incomplete</td>
        <td class="vertical-align-unset text-center">{{allUsers.incompleteJourneyCount?
          allUsers.incompleteJourneyCount : '0'}}</td>
        <td class="vertical-align-unset text-center"> - </td>
      </tr>
      <tr><td colspan="3"><b>Loan Ref no not generated</b></td></tr>
      <tr>
        <td>Failure Applications </td>
        <td class="vertical-align-unset text-center">{{allUsers.failureCountBeforeReference?
          allUsers.failureCountBeforeReference : '0'}}</td>
        <td class="vertical-align-unset text-center"> - </td>
      </tr>
      



    </tbody>

  </table>
  </div>

</wl-card>